export const contactUs = {
    mapUrl: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d1530.751086101226!2d-134.88376499999998!3d67.43915299999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNjfCsDI2JzIxLjAiTiAxMzTCsDUzJzAxLjYiVw!5e0!3m2!1sen!2slk!4v1710528794070!5m2!1sen!2slk&output=embed",
    subTitle: {
        first: "Contact",
        second: "Us",
    },
    title: "Let’s Get in Touch",
};
